'use client';

import { CheckCircle2 } from 'lucide-react';

import HLSVideoPlayer from '@/shared/components/hls-video-player/hls-video-player';

import { useVideoRecording } from '../video-recording-provider';
import { ActionButtons, RECORDED_VIDEO_PLAYER_CLASS, VideoContainer } from './shared';

export function SavedView() {
	const { videoState, uiState } = useVideoRecording();

	return (
		<>
			<VideoContainer
				badge={
					<span className="flex items-center gap-1 rounded-full bg-green-100 px-2 py-1 text-xs font-semibold text-green-700">
						<CheckCircle2 className="h-4 w-4 text-green-500" /> Saved
					</span>
				}
			>
				{videoState.savedVideoUrl && (
					<HLSVideoPlayer
						videoUrl={videoState.savedVideoUrl}
						className={RECORDED_VIDEO_PLAYER_CLASS}
						videoClassName={uiState.isPortrait ? 'object-contain' : undefined}
					/>
				)}
			</VideoContainer>

			<ActionButtons variant="saved" />
		</>
	);
}
